/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import {de} from 'date-fns/locale/de'
import {nl} from 'date-fns/locale/nl'
import {hu} from 'date-fns/locale/hu'
import {sk} from 'date-fns/locale/sk'
import {enGB} from 'date-fns/locale'

import {Locale} from 'date-fns'
import dayjs from "dayjs";
import "dayjs/locale/de";
import "dayjs/locale/de-ch";
import "dayjs/locale/nl";
import "dayjs/locale/sk";
import "dayjs/locale/hu";
import "dayjs/locale/en";

import {default as NL_locale} from "antd/es/locale/nl_NL";
import {default as SK_locale} from "antd/es/locale/sk_SK";
import {default as HU_locale} from "antd/es/locale/hu_HU";
import {default as EN_locale} from "antd/es/locale/en_GB";
import {default as DE_locale, default as DE_CH_locale} from "antd/es/locale/de_DE";

export const declareLocaleByConfig = (locale: string): Locale => {
    switch (locale) {
        case 'en':
        case 'en-GB':
            return enGB
        case 'de':
        case 'de-CH':
        case 'de-DE':
            return de
        case 'nl':
        case 'nl-NL':
            return nl
        case 'hu':
        case 'hu-HU':
            return hu
        case 'sk':
        case 'sk-SK':
            return sk
        default:
            return enGB
    }
}


export const localeObject = (locale: string) => {
	switch (locale) {
		case "nl-NL":
			dayjs.locale("nl");
			return NL_locale;
		case "sk-SK":
			dayjs.locale("sk");
			return SK_locale;
		case "hu-HU":
			dayjs.locale("hu");
			return HU_locale;
		case "de-DE":
			dayjs.locale("de");
			return DE_locale;
		case "de":
		case "de-CH":
			dayjs.locale("de-ch");
			return DE_CH_locale;
		case "en":
		case "en-GB":
			dayjs.locale("en");
			return EN_locale;
		default:
			dayjs.locale("en");
			return EN_locale;
	}
};